import {
    Component, ElementRef, Input, HostListener, OnInit, ViewEncapsulation, HostBinding,
    OnDestroy, Output, EventEmitter
} from '@angular/core';
import { VgAPI } from '../../core/services/vg-api';
import { VgControlsHidden } from './../../core/services/vg-controls-hidden';
import { VgStates } from '../../core/states/vg-states';
import { fromEvent, Subscription } from 'rxjs';
import { VgUtils } from '../../core';
import { VgSeekBarApi } from '../../core/services/vg-seekbar-api';
import { Utility } from '../../../../_service/utility';
//
@Component({
    selector: 'vg-scrub-bar',
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="scrubBar"
             tabindex="0"
             role="slider"
             aria-label="scrub bar"
             [attr.aria-valuenow]="getPercentage()"
             aria-valuemin="0"
             aria-valuemax="100"
             (mousemove)="onMouseOver($event)"
             >
            <ng-content></ng-content>
            <div class="overshow" [ngStyle]="{'left':percetange,'visibility':!!loadingImage?'visible':'hidden'}" *ngIf="!istouchdevice && playerReady" [ngClass]="{hasPreview:!!previewFormat,vertical:isVertical}" (mousedown)="moveTo($event)">
                <div class="preview" [ngStyle]="preview"></div>
                <div class="scru-t">{{display}}</div>
                <img src="{{loadingImage}}" (load)="imageLoaded($event)" *ngIf="loadingImage" style="width:1px;height:1px;visibility:hidden"/>
            </div>
        </div>

    `,
    styles: [`
        vg-scrub-bar {
            user-select: none;
            width: 100%;
            height: 5px;
            margin: 0;
            cursor: pointer;
            align-items: center;
            background: rgba(0, 0, 0, 0.75);
            z-index: 250;
            position:absolute;
        }

        vg-scrub-bar .scrubBar {
            position: relative;
            display: flex;
            flex-grow: 1;
            align-items: center;
            height: 1.2em;
            margin-top: -0.5em;
        }

        vg-controls vg-scrub-bar {
            background: transparent;
            height: 50px;
            flex-grow: 1;
            flex-basis: 0;
            margin: 0 10px;

        }

        vg-scrub-bar.hide {
            opacity: 0;
        }

        vg-controls vg-scrub-bar.hide {
            opacity: initial;
        }
        .scrubBar .overshow{
            position: absolute;
            background-color: black;
            text-align: center;
            font-size: 15px;
            color: white;
            border: 1px solid black;
            transform: translateX(-50%);
            bottom: 10px;
            box-sizing: content-box;
            opacity:0;
            transition-property: opacity;
            transition-duration: 0.2s;
            display:block;
            
        }
        .scrubBar .overshow.hasPreview
        {
            width:160px;
            height:90px;

        }
        .scrubBar .overshow.hasPreview.vertical
        {
            width:90px;
            height:160px;

        }
        .scrubBar:hover .overshow{


            opacity:1;
        }
        .preview
        {
            background-repeat: no-repeat;
            width: 160px;
            height: 90px;
            position: absolute;
            left: 0;
            top: 0;
            display:none;

        }
        .overshow.hasPreview .preview
        {
            display:block;
        }
        .overshow.hasPreview.vertical .preview
        {
            width: 90px !important;
            height: 160px !important;
        }
        .scru-t
        {
            position: absolute;
            bottom: 0em;
            background-color: rgba(0, 0, 0, 0.68);
            padding: 0.2em 0.5em;
            left: 50%;
            transform: translateX(-50%);
            font-size: 13px;

        }
        .overshow.hasPreview .scru-t
        {
            border-radius: 0.5em 0.5em 0 0;
        }

    ` ]
})
export class VgScrubBar implements OnInit, OnDestroy {
    @HostBinding('class.hide') hideScrubBar: boolean = false;
   // @HostBinding('class.focus') focus: boolean = false;

    @Input() vgFor: string;
    @Input() vgSlider: boolean = true;
    @Input() previewFormat = "";
    get istouchdevice() {
        return VgUtils.isTouchDevice;
    }

    // = VgUtils.isTouchDevice;
    elem: HTMLElement;
    target: any;
    isSeeking: boolean = false;
    wasPlaying: boolean = false;
    display = "";
    percetange = "0%";
    subscriptions: Subscription[] = [];
    playerReady = false;
    devicePixelRatio = 1;
    isVertical = false;
    @Input() isLive;
    @Input() isPlayingAds = false;
    constructor(ref: ElementRef,
        public API: VgAPI,
        vgControlsHiddenState: VgControlsHidden,
        public vgSeekBarAPI: VgSeekBarApi,
        private _utility:Utility

    ) {
        this.elem = ref.nativeElement;
        this.subscriptions.push(vgControlsHiddenState.isHidden.subscribe(hide => this.onHideScrubBar(hide)));
        this.devicePixelRatio = this._utility.getZoomRatio();
        // var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
        // if (isMac) {
        //     // if (window.devicePixelRatio >= 2) {
        //     //     this.devicePixelRatio = (window.devicePixelRatio / 2);
        //     // }
        // } else {
        //     // this.devicePixelRatio = window.innerWidth < 1366 ? window.devicePixelRatio : 1; // innerWidth如果小于1366启用
        //     // this.devicePixelRatio = window.innerWidth < 1366 ? (1366 / window.innerWidth) : 1; // innerWidth如果小于1366启用，使用最小尺寸
        //     this.devicePixelRatio = window.innerWidth < 1366 ? (1366 / window.innerWidth) : window.innerWidth > 2560 ? (1920 / window.innerWidth) : 1; // innerWidth如果小于1366启用，使用最小尺寸;大于2560启用，使用最大尺寸
        // }
    }


    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
            //this.subscriptions.push(this.target.subscriptions.)
        }
        this.subscriptions.push(
            fromEvent(this.elem, "touchstart", {
                passive: true
            }).subscribe(p => {
                this.onTouchStartScrubBar(p);
            }),
            fromEvent(this.elem, "mousedown").subscribe(p => {
                this.onMouseDownScrubBar(p);
            }),
            fromEvent(this.elem, "mousemove", {
                passive: true
            }).subscribe(p => {
                this.onMouseOverBar()
            }),
            fromEvent(this.elem, "mouseout", { passive: true }).subscribe(p => {
                this.onMouseOut();
            }),
            fromEvent(document, "mousemove", {
                passive: true
            }).subscribe(p => {
                this.onMouseMoveScrubBar(p);
            }),

            fromEvent(document, "mouseup").subscribe(p => {
                this.onMouseUpScrubBar(p);
            }),

            fromEvent(document, "touchmove", {
                passive: true
            }).subscribe(p => {
                this.onTouchMoveScrubBar(p);
            }),

            fromEvent(document, "touchcancel").subscribe(p => {
                this.onTouchCancelScrubBar(p);
            }),
            fromEvent(document, "touchend").subscribe(p => {
                this.onTouchEndScrubBar(p);
            }),
            fromEvent(document, "keydown").subscribe(p => {
                this.arrowAdjustVolume(p as KeyboardEvent);
            })
        )
    }

    onPlayerReady() {
        this.target = this.API.getMediaById(this.vgFor);
        this.playerReady = true;
    }

  
    private width = 160;
    private height = 90;
    protected seekStart(event) {

        if (this.target.canPlay) {
            //console.log("seek start")
            this.isSeeking = true;
            if (this.target.state === VgStates.VG_PLAYING) {
                this.wasPlaying = true;
            }
            //this.target.isSeeking = true;
            // this.target.pause();
            this.hasPaused = true;
            var offsetX = this.getPosition(this.elem).left;//.offsetLeft;
            var position = Math.ceil(event.clientX * this.devicePixelRatio) - offsetX;
            position = position >= 0 ? position : 0;
            let percentage = Math.max(Math.min(position * 100 / (this.elem.scrollWidth), 99.9), 0);
            this.target.time.current = percentage * this.target.time.total / 100;
            this.target.seekTime(percentage, true);
            this.vgSeekBarAPI.notify("seekstart");
            this.noJump = true;
        }
    }
    noJump = false;
    asClick = null;
    public hasPaused = false;
    public timeout = null;
    protected seekMove(offset: number) {
      //  console.log("move")
        this.noJump = false;
        if (this.isSeeking) {
            if (this.asClick) {
                VgUtils.clearTimeout(this.asClick);
                this.asClick = null;
            }
            else {
                if (!this.hasPaused) {
                    this.hasPaused = true;
                    this.target.pause();
                }
            }
            //console.log(Math.min(offset * 100 / (this.elem.scrollWidth)),offset);
            let percentage = Math.max(Math.min(offset * 100 / (this.elem.scrollWidth), 99.9), 0);
            this.target.time.current = percentage * this.target.time.total / 100;
            //console.log(percentage);
            // if (this.timeout != null) {
            //     VgUtils.clearTimeout(this.timeout);
            // }
            // this.timeout = VgUtils.setTimeout(() => this.target.seekTime(percentage, true), 20);
            this.target.seekTime(percentage, true);
        }
    }

    imageLoaded(event) {
        let target = event.target as HTMLImageElement;
        this.isVertical = false;
        if(target?.naturalHeight>0 && target?.naturalWidth>0)
        {
            this.isVertical = target.naturalHeight / target.naturalWidth>1;
        }

        if(this.isVertical)
        {
            this.width = 90;
            this.height = 160;
        }
        else
        {
            this.width = 160;
            this.height = 90;
        }
        //console.log(target.naturalWidth,target.naturalHeight)
        this.preview["background-image"] = "url('" + this.loadingImage + "')";
        if (this.x > 0) {
            this.preview["background-position-x"] = - this.x + "px";
        }
        else {
            this.preview["background-position-x"] = "0";
        }
        if (this.y > 0) {
            this.preview["background-position-y"] = -this.y + "px";
        }
        else {
            this.preview["background-position-y"] = "0";

        }
    }
    protected seekEnd(offset: number) {

        //console.log("seek end",this.target.canPlay)
        if (this.target.canPlay) {

            if(!this.noJump)
            { 
                VgUtils.clearTimeout(this.timeout);
                let percentage = Math.max(Math.min(offset * 100 / (this.elem.scrollWidth), 99.9), 0);
                this.timeout = VgUtils.setTimeout(() => {
                    this.target.seekTime(percentage, true);
                    //console.log("was playing",this.wasPlaying)
                    this.target.time.current = percentage * this.target.time.total / 100;
                    if (this.wasPlaying) {
                        this.wasPlaying = false;
                        this.target.play();
                    }
                    this.vgSeekBarAPI.notify("seekend");
                }, 20);

            }
           
            this.isSeeking = false;


        }
        //console.log("seek end")
    }

    protected touchEnd() {
        this.isSeeking = false;
        if (this.wasPlaying) {
            this.wasPlaying = false;
            this.target.play();
        }
    }

    protected getTouchOffset(event: any) {
        let offsetLeft: number = 0;
        let element: any = event.target;
        while (element) {
            offsetLeft += element.offsetLeft;
            element = element.offsetParent;
        }
        return event.touches[0].pageX - offsetLeft;
    }

    //@HostListener('mousedown', ['$event'])
    onMouseDownScrubBar($event: any) {
        if (this.target) {
            if (!this.target.isLive) {
                this.seekStart($event);
                // if (!this.vgSlider) {
                //     this.seekEnd($event.offsetX);
                // }
                // else {
                //     // console.log("seek start");
                //     this.seekStart($event);
                // }
            }
        }
    }

    // @HostListener('click', [ '$event' ])
    // onClick($event: any) {
    //     if (this.target) {
    //         if (!this.target.isLive) {
    //             if (!this.vgSlider) {
    //                 this.seekEnd($event.offsetX);
    //             }
    //             else {
    //                 //console.log("seek end");

    //                 this.seekEnd($event.offsetX);
    //             }
    //         }
    //     }
    // }

    getPosition(elem: HTMLElement) {

        var rect = elem.getBoundingClientRect();
        // Make sure element is not hidden (display: none) or disconnected
        if (rect.width || rect.height || elem.getClientRects().length) {

            return {
                top: rect.top + window.pageYOffset - document.documentElement.clientTop,
                left: rect.left + window.pageXOffset - document.documentElement.clientLeft
            };
        }
        return {
            top: 0,
            left: 0
        };
    }

    // @HostListener('document:mousemove', ['$event'])
    onMouseMoveScrubBar($event: any) {

        if (VgUtils.shouldHandleMouse) {

            if (this.target) {
                if (!this.target.isLive
                    && this.vgSlider
                    && this.isSeeking
                ) {
                    var offsetX = this.getPosition(this.elem).left;//.offsetLeft;
                    //var offsetWidth = this.elem.offsetWidth;
                    var position = Math.ceil($event.clientX * this.devicePixelRatio) - offsetX;
                    position = position >= 0 ? position : 0;
                    // console.log(position);
                    this.seekMove(position);//$event.offsetX);

                    // if($event.clientX >= offsetX &&
                    //     $event.clientX <= offsetX + offsetWidth)
                    //     {


                    //     }
                }
            }
        }

    }

    onMouseOver($event: any) {

        if (VgUtils.shouldHandleMouse) {
            if (this.target && !this.target.isLive && $event.target != null && ($event.target as HTMLElement).className.indexOf("scrubBar") > -1) {

                let percentage = Math.max(Math.min($event.offsetX / (this.elem.scrollWidth) * this.devicePixelRatio, 0.999), 0);
                var time = this.target.time.total * percentage;
                this.percetage = percentage;
                this.showPreview(time)
                let date = new Date(time);
                let result = "hh:mm:ss";
                let ss: string | number = date.getUTCSeconds();
                let mm: string | number = date.getUTCMinutes();
                let hh: string | number = date.getUTCHours();

                if (ss < 10) {
                    ss = '0' + ss;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                if (hh < 10) {
                    hh = '0' + hh;
                }

                result = result.replace(/ss/g, <string>ss);
                result = result.replace(/mm/g, <string>mm);
                result = result.replace(/hh/g, <string>hh);
                if (result.indexOf("NaN") == -1) {
                    this.display = result;

                    if (percentage > 0.90) {
                        percentage = 0.90;
                    }
                    if (percentage < 0.1) {
                        percentage = 0.1;
                    }
                    this.percetange = percentage * 100 + "%";
                }
                else {
                    this.display = "00:00:00";
                }
                // console.log(time);
                //console.log(percentage)
            }
            //clearTimeout(this.mouseOuttime);

        }

    }
    // mouseOuttime = null;
    showtimeout = null;
    firstTime = true;
    loadingImage = null;
    x = 0;
    y = 0;
    private showPreview(time) {
        //  console.log(time)
        clearTimeout(this.showtimeout);
        this.showtimeout = setTimeout(() => {
            if (!!this.previewFormat && !isNaN(time) && time >= 0) {
                var seconds = Math.ceil(time / 1000);
                var group = Math.ceil(seconds / this.imagePerview) - 1; // parseInt( "" + (seconds %this.imagePerview ==0?seconds/this.imagePerview:seconds /this.imagePerview+1));

                if (!isNaN(group)) {
                    //console.log(group)
                    var which = seconds % this.imagePerview;

                    let url = this.previewFormat.replace("{group}", group + "");
                    this.loadingImage = url;
                    this.x = (which % 5) * this.width;
                    this.y = Math.floor(which / 5) * this.height;
         
                }

            }

        }, this.firstTime ? 10 : 100);
        this.firstTime = false;

        //  console.log(time,seconds,group,x,y,this.previewFormat);
    }
    ///一组图片的数量
    imagePerview = 25;

    // @HostListener('document:mouseup', ['$event'])
    onMouseUpScrubBar($event: any) {
        if (VgUtils.shouldHandleMouse) {
            if (this.target) {
                var offsetX = this.getPosition(this.elem).left;//.offsetLeft;
                var position = Math.ceil($event.clientX * this.devicePixelRatio) - offsetX;
                position = position >= 0 ? position : 0;
                // console.log($event.offsetX,position)
                if (!this.target.isLive && this.vgSlider && this.isSeeking) {
                    this.seekEnd(position);
                    // console.log("seek end")
                }

                // console.log("call")
            }
        }
    }

    // @HostListener('touchstart', ['$event'],)
    onTouchStartScrubBar($event: any) {
        //console.log("touch");

        if (!VgUtils.shouldHandleMouse) {
            if (this.target) {
                if (!this.target.isLive) {
                    if (!this.vgSlider) {
                        this.seekEnd(this.getTouchOffset($event));
                    }
                    else {

                        if (this.asClick != null) {
                            VgUtils.clearTimeout(this.asClick);

                        }
                        var posX = this.getTouchOffset($event);

                        this.asClick = VgUtils.setTimeout(() => {
                            this.seekEnd(posX);
                        }, 250);

                        this.seekStart($event);
                    }
                }
                //$event.stopPropagation();
            }
        }

    }

    // @HostListener('document:touchmove', ['$event'])
    onTouchMoveScrubBar($event: any) {
        if (!VgUtils.shouldHandleMouse) {
            if (this.target) {
                if (!this.target.isLive && this.vgSlider && this.isSeeking) {
                    this.seekMove(this.getTouchOffset($event));
                }
            }
        }
    }

    // @HostListener('document:touchcancel', ['$event'])
    onTouchCancelScrubBar($event: any) {
        if (!VgUtils.shouldHandleMouse) {
            if (this.target) {
                if (!this.target.isLive && this.vgSlider && this.isSeeking) {
                    this.touchEnd();
                }
            }
        }
    }

    // @HostListener('document:touchend', ['$event'])
    onTouchEndScrubBar($event: any) {
        if (!VgUtils.shouldHandleMouse) {
            if (this.target) {
                if (!this.target.isLive && this.vgSlider && this.isSeeking) {
                    this.touchEnd();
                }
            }
        }
    }

    @Output() onClosePlayEndContent = new EventEmitter<any>();
    // @HostListener('document:keydown', ['$event'])
    arrowAdjustVolume(event: KeyboardEvent) {
        //console.log(event.keyCode ,"aaa")
        if (this.isLive) {
            return;
        }

        if (this.isPlayingAds) {
            return;
        }

        var active = document.activeElement;
        if (!(active == null || (
            active.tagName.toLowerCase() != "input" &&
            active.tagName.toLowerCase() != "textarea" &&
            !active.hasAttribute("contenteditable")
        ))) return;

        if (this.target) {
            if (event.keyCode === 39) {
                event.preventDefault();
                this.target.seekTime((this.target.time.current + 5000) / 1000, false);
            }
            else if (event.keyCode === 37) {
                event.preventDefault();
                this.onClosePlayEndContent.emit(false);
                this.target.seekTime((this.target.time.current - 5000) / 1000, false);
            }
        }
    }

    getPercentage() {
        return this.target &&  !!this.target.time ? this.target.time.current * 100 / (this.target.time.total) + '' : '0';
    }

    onHideScrubBar(hide: boolean) {
        this.hideScrubBar = hide;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
    //@HostListener('mousemove')
    onMouseOverBar() {
       // this.focus = true;
        clearTimeout(this.outTime);
    }
    //@HostListener('mouseout', ['$event'])
    outTime = null;
    onMouseOut() {
        this.firstTime = false;
        clearTimeout(this.outTime);
        this.outTime = setTimeout(()=>{
            this.loadingImage = null;
            this.preview = {};
        },100);
      
    }
    percetage = 0;
    moveTo(event) {

        VgUtils.clearTimeout(this.timeout);
        this.timeout = VgUtils.setTimeout(() => {
            this.target.seekTime(this.percetage * 100, true);
        }, 20);
        event.preventDefault();
        event.stopPropagation();

    }
    preview = {};
}
